export default __webpack_public_path__ + "static/hubert_klim-5a22a08d6da59a00d85a72c1713b5f54.jpg";